module.exports = __webpack_public_path__ + "static/img/courseOver.44b1613.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/courseOver.jpg
// module id = KJoS
// module chunks = 14